import { styled } from '@mui/material'

export const WebsocketStatusContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-right: 16px;
`
export const WebsocketStatus = styled('div')<{ active: boolean }>`
  height: 12.5px;
  width: 12.5px;
  border-radius: 50px;
  background-color: ${({ active }) => (active ? 'green' : 'red')};
  margin-right: 8px;
`
